import React from 'react';
import ThemeContext from '@material-ui/styles/esm/useTheme/ThemeContext.js';

// Vite 8's Rolldown prebundle of @material-ui/styles/ThemeProvider calls
// React.useMemo before its lazy React import is initialized. This wrapper
// bypasses that broken chunk while preserving the same behavior for a static theme.
export default function ThemeProvider({ children, theme }) {
  return (
    <ThemeContext.Provider value={theme}>{children}</ThemeContext.Provider>
  );
}
